import { useState, useCallback } from "@";

// Hook for row selection in a table
export const useRowSelection = () => {
  const [selectedIDs, setSelectedIDS] = useState([]);

  const handleSelect = useCallback(({ selectedRows }) => {
    const ids = selectedRows.map((el) => el?.id);
    const filteredIds = ids.filter((id) => id !== "customRow");

    setSelectedIDS(filteredIds);
  }, []);

  return {
    selectedIDs,
    handleSelect,
  };
};
